import React, { useCallback, useMemo } from "react";
import { InputCard } from "components/InputCards/InputCard";
import { Select } from "components/Select/Select";

const labelReplace = (str) =>
  str.replace(
    /\\([a-zA-Z0-9,]+)\\s*/g, // change the stringformat a\\b\\ to a<sub>b</sub>
    "<sub>$1</sub>",
  );

export const Property = ({
  property,
  isValueEditable,
  onChange,
  propertyStyles,
}) => {
  const {
    id,
    presentation,
    symbol,
    valueMin,
    valueMax,
    unit,
    value,
    values,
    displayValue,
    validationMessage,
    validationType,
  } = property;

  const options = useMemo(
    () =>
      Array.isArray(values) && values.length > 0
        ? values.map((opt) => ({
            value: opt.key,
            label: opt.value,
          }))
        : [],
    [values],
  );

  const selectedOption = useMemo(
    () => options && options.find((opt) => opt.value === value),
    [options, value],
  );

  const subLabel = useMemo(
    () =>
      !isNaN(valueMin) &&
      valueMin !== null &&
      `${valueMin} ${
        !isNaN(valueMax) && valueMax !== null ? `.. ${valueMax}` : ".."
      } ${unit}`,
    [unit, valueMax, valueMin],
  );

  const handleChange = useCallback(
    (inputValue) => {
      if (onChange) {
        onChange({
          changeInput: {
            inputValue,
            inputId: id,
          },
        });
      }
    },
    [id, onChange],
  );

  return (
    <>
      {values?.length ? (
        <div className={propertyStyles}>
          <div className="font-md ps-2">{labelReplace(presentation)}</div>
          {values.length > 1 ? (
            <Select
              options={options}
              value={selectedOption}
              onChange={(opt) => handleChange(opt.value)}
              testId={id}
            />
          ) : (
            <div className="align-items-start" style={{ minWidth: "6.5rem" }}>
              {values[0].value}
            </div>
          )}
        </div>
      ) : (
        <InputCard
          label={`${labelReplace(presentation)} ${labelReplace(symbol)}`}
          subLabel={subLabel}
          value={value}
          displayValue={displayValue}
          valueMin={valueMin}
          valueMax={valueMax}
          unit={unit}
          isValueEditable={isValueEditable}
          onChange={handleChange}
          testId={`${id}`}
          validationMessage={validationMessage}
          validationType={validationType}
        />
      )}
    </>
  );
};
